import { useContext } from 'react';

import { RoleManagementModalContext } from './role-management-modal-provider';

function useRoleManagementModal() {
  const context = useContext(RoleManagementModalContext);

  if (!context) {
    throw new Error('useRoleManagementModal must be used within a RoleManagementModalProvider');
  }

  return context;
}

export { useRoleManagementModal };
